const ABOUT_IMAGE = "https://customer-assets-4nw71qhi.emergentagent.net/job_7e4e61dd-6912-4af3-ac17-762c1ac12aa9/artifacts/f62wp3vh_WhatsApp%20Image%202026-09-05%20at%2012.11.27%20%281%29.jpeg";
const GYP_LOGO = "/gyp-logo.png";

const NAVY = "#0E1B3D";
const GOLD = "#B8944D";

export default function About() {
  return (
    <section
      id="about"
      className="bg-paper border-t"
      style={{ borderColor: "rgba(14,27,61,0.10)" }}
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-24 lg:py-32">

        {/* Header */}
        <div className="grid md:grid-cols-12 gap-8 mb-20">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-6">
              <span className="gold-rule" />
              <p className="text-[10px] tracking-[0.4em] uppercase" style={{ color: GOLD }}>
                About the Organization
              </p>
            </div>
            <div className="flex items-start gap-4">
              <img src={GYP_LOGO} alt="GYP" className="h-14 w-14 object-contain logo-clean shrink-0" />
              <div>
                <h2 className="font-serif text-2xl leading-tight" style={{ color: NAVY }}>Global Youth<br />Platform</h2>
                <p className="text-xs tracking-[0.15em] uppercase mt-2" style={{ color: GOLD }}>
                  International Organization
                </p>
              </div>
            </div>
          </div>

          <div className="md:col-span-8">
            <h3 className="font-serif text-3xl lg:text-5xl leading-[1.05] mb-8" style={{ color: NAVY }}>
              We convene young leaders at the world&apos;s most consequential venues — and prepare them
              <span style={{ color: GOLD, fontStyle: "italic", fontWeight: 300 }}> to lead.</span>
            </h3>
            <p className="text-lg leading-relaxed text-slate max-w-2xl" style={{ color: "#3A4256" }}>
              GYP is an international organization dedicated to cultivating the next generation
              of diplomatic leadership. Through structured programs at institutions such as the
              United Nations, we equip young people with the exposure, training, and networks
              they need to shape the world they will inherit.
            </p>
          </div>
        </div>

        {/* Image + credibility */}
        <div className="grid lg:grid-cols-12 gap-8 items-stretch">

          {/* Image */}
          <div className="lg:col-span-7 relative min-h-[400px] lg:min-h-[560px] overflow-hidden">
            <img
              src={ABOUT_IMAGE}
              alt="GYP session at the United Nations Conference Centre"
              className="absolute inset-0 w-full h-full object-cover img-editorial"
              data-testid="about-image"
            />
            <div className="absolute inset-x-0 bottom-0 p-6 text-white" style={{ background: "linear-gradient(to top, rgba(6,11,34,0.9), transparent)" }}>
              <p className="text-[10px] tracking-[0.35em] uppercase mb-1" style={{ color: GOLD }}>Bangkok · June 2026</p>
              <p className="font-serif text-2xl">GYP International Leadership Program</p>
              <p className="text-white/70 text-xs mt-1">United Nations Conference Centre · 330+ delegates · 60+ nations</p>
            </div>
          </div>

          {/* Numbers */}
          <div className="lg:col-span-5 flex flex-col justify-between space-y-6">
            {[
              { value: "330+", label: "Delegates convened", note: "United Nations Conference Centre, Bangkok" },
              { value: "60+", label: "Nations represented", note: "Every continent, one convening" },
              { value: "50", label: "Delegates · Barcelona 2027", note: "Selective flagship program" },
              { value: "3+", label: "Institutional partners", note: "Working with international bodies" },
            ].map((m, i) => (
              <div key={m.label} className="flex items-baseline gap-6 py-4 border-b" style={{ borderColor: "rgba(14,27,61,0.10)" }}>
                <p className="font-serif text-5xl lg:text-6xl leading-none shrink-0 counter" style={{ color: NAVY }}>
                  {m.value}
                </p>
                <div>
                  <p className="text-[11px] tracking-[0.3em] uppercase mb-1" style={{ color: NAVY }}>{m.label}</p>
                  <p className="text-xs text-slate" style={{ color: "#7B8393" }}>{m.note}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
